import { TrainingJobStatusGroup } from '@/sections/Training/utils';

const MAX_ITEMS_TO_SHOW = 6;
const TRAINING_JOB_FILTERS = ['ALL' as const, ...Object.values(TrainingJobStatusGroup)];
export { TRAINING_JOB_FILTERS, MAX_ITEMS_TO_SHOW };
